// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hk-0";
export var fulfillmentPanelBody = "_hk-1";